import './UploaderLoading.css';

function UploaderStatusLoading() {
  return (
    <div className="uploader-container">
      <div class="uploader">
        <p class="uploader-text">
          Uploading....
        </p>
        <div class="upload-animation-blue-container">
          <div class="upload-animation-blue-item">
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploaderStatusLoading;